/**
 * An event dispatched when the component moves into or out of view.
 */
export const ViewportIntersectionObserverUpdatedEventType =
  "tqc:viewport-intersection-observer:updated";
class ViewportIntersectionObserverUpdatedEvent extends Event {
  constructor(entry) {
    super(ViewportIntersectionObserverUpdatedEventType, {
      bubbles: true,
    });

    this.intersectionObserverEntry = entry;
    this.inView = entry.isIntersecting;
  }
}

/**
 * This component uses an event to announce when it passes in or out of the viewport.
 *
 * Uses the web standard IntersectionObserver API:
 * https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
 *
 * @emits: tqc:viewport-intersection-observer:updated once on initial load, and any time
 *         the intersection changes.
 */
class ViewportIntersectionObserver extends HTMLElement {
  constructor() {
    super();

    this.observer = new IntersectionObserver(this.handleIntersectionUpdate, {
      threshold: [0],
    });
  }

  handleIntersectionUpdate = (entries) => {
    entries.forEach((entry) => {
      this.dispatchEvent(new ViewportIntersectionObserverUpdatedEvent(entry));
    });
  };

  connectedCallback() {
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }
}

customElements.define(
  "viewport-intersection-observer",
  ViewportIntersectionObserver,
);
